import { SavedArticlesComponent } from 'components/main/saved-articles/saved-articles.component'
export default SavedArticlesComponent
